export enum AnimationEnum {
	FADE_IN = 'fade-in',
	BOUNCE = 'bounce',
	SLIDE_UP = 'slide-up',
	SLIDE_DOWN = 'slide-down',
	SLIDE_LEFT = 'slide-left',
	SLIDE_RIGHT = 'slide-right',
}

export enum PositionLayoutEnum {
	CENTER = 'center',
	CENTER_LEFT = 'center-left',
	CENTER_RIGHT = 'center-right',
	TOP_CENTER = 'top-center',
	TOP_LEFT = 'top-left',
	TOP_RIGHT = 'top-right',
	BOTTOM_CENTER = 'bottom-center',
	BOTTOM_LEFT = 'bottom-left',
	BOTTOM_RIGHT = 'bottom-right',
}

export enum TimingTypeEnum {
	TIMER = 'timer',
	SCROLL = 'scroll',
}

type ComponentDataT = WebBlocksApiComponentT | string | null;

export type ComponentPropsT = AllHTMLAttributes & {
	children?: ComponentDataT | ComponentDataT[];
};

export type ComponentT = {
	type: string;
	props: ComponentPropsT;
};

export type PopupBackgroundType = {
	color?: string;
	opacity?: number;
};

type CardPayloadType = {
	actionButton: {
		link: string;
		style?: {
			backgroundColor?: string;
			color?: string;
			borderRadius?: string;
			textAlign?: string;
			fontSize?: string;
			textDecoration?: string;
			fontStyle?: string;
			fontWeight?: string;
		};
		text: string;
	};
	image: {
		src: string;
	};
	style?: {
		width?: string;
		backgroundColor?: string;
		height?: string;
		background?: PopupBackgroundType;
	};
	bodyText: {
		style?: {
			color?: string;
			textAlign?: string;
			fontSize?: string;
			textDecoration?: string;
			fontStyle?: string;
			fontWeight?: string;
		};
		text: string;
	};
};

type BannerPayloadType = {
	image: {
		link: string;
		src: string;
	};
	style?: {
		width?: string;
		height?: string;
		background?: PopupBackgroundType;
	};
};

type HTMLPayloadType = {
	component: ComponentT;
	style?: {
		width?: string;
		height?: string;
		background?: PopupBackgroundType;
	};
};

type BaseCampaignType<T> = {
	campaignId: string;
	contentId: string;
	templateId: number;
	payload: T;
	options: {
		animation: AnimationEnum;
		position: { layout: PositionLayoutEnum; offsetX: number; offsetY: number };
		timing: { type: TimingTypeEnum; activate: number };
		stopCondition?: { viewTotal: number; closeTotal: number };
		trigger?: { visit: integer | null; displayTimer?: number | null };
	};
};

export type CampaignType = BaseCampaignType<
	CardPayloadType | BannerPayloadType | HTMLPayloadType
>;
